import { render, staticRenderFns } from "./ListMyWallet.vue?vue&type=template&id=43268988&"
import script from "./ListMyWallet.vue?vue&type=script&lang=js&"
export * from "./ListMyWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports